import i18n from '@i18next/i18n';
import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import { ICommentApi, ICommentWithVipInfo } from '../../../type';
import CommentInput from '../comment-input/comment-input';
import FOLD_ICON from '../icon/fold-icon.svg';
import Style from '../index.less';
import CommentGroupItem from './comment-group-item';
import CommentGroupEditorItem from './comment-group-item/comment-group-editor-item';

interface ICommentGroupProps extends ICommentApi {
    groupId: string;
    isElementAnchorHover?: boolean;
    isActive?: boolean;
    commentGroupInfoList: ICommentWithVipInfo[];
    onActive: (groupId: string) => void;
    onMouseOver: (groupId: string) => void;
    onMouseOut: () => void;
}

const CommentGroup: React.FC<ICommentGroupProps> = (props: ICommentGroupProps) => {
    const [editableCommentId, setEditableCommentId] = useState('');
    const commentGroupItemWrapperRef = useRef<any>();

    const { groupId, commentGroupInfoList, isActive } = props;

    const renderComment = (index: number) => {
        const commentInfo = commentGroupInfoList[index];
        return commentInfo.id === editableCommentId
            ? <CommentGroupEditorItem
                commentInfo={commentInfo}
                groupId={groupId}
                addComment={props.addComment}
                updateComment={props.updateComment}
                onEditStateChanged={handleEditStateChanged}
                isLastItem={index === commentGroupInfoList.length - 1}
                key={commentInfo.id}
            />
            : <CommentGroupItem
                commentIndex={index}
                commentInfo={commentInfo}
                groupId={groupId}
                isGroupActive={isActive}
                deleteComment={props.deleteComment}
                deleteCommentGroup={props.deleteCommentGroup}
                onEditStateChanged={handleEditStateChanged}
                isLastItem={index === commentGroupInfoList.length - 1}
                key={commentInfo.id}
            />;
    };

    /**
     * 折叠状态最多显示 3 条评论
     */
    const renderList = () => {
        const commentLength = commentGroupInfoList.length;
        if (commentLength === 0) return null;
        if (commentLength <= 3 || isActive) {
            return commentGroupInfoList.map((commentInfo, index) => renderComment(index));
        }
        return [
            renderComment(0),
            <div key='fold-comments' className={Style['folded-tips']}>
                <img src={FOLD_ICON} alt=''></img>
                <span>{i18n.t('已折叠 {0} 条批注', { 0: commentLength - 3 })}</span>
            </div>,
            renderComment(commentLength - 2),
            renderComment(commentLength - 1),
        ];
    };

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        props.onActive(groupId);
    };

    const handleEditStateChanged = (commentId?: string, isEditing?: boolean) => {
        if (isEditing) {
            if (commentId && commentId !== editableCommentId) {
                setEditableCommentId(commentId);
            }
        } else {
            setEditableCommentId('');
        }
    };

    return <div
        className={classNames({
            [Style['comment-group']]: true,
            [Style['comment-group-active']]: isActive,
            [Style['comment-group-hover']]: props.isElementAnchorHover,
        })}
        onClick={handleClick}
        onMouseOver={() => props.onMouseOver(groupId)}
        onMouseOut={props.onMouseOut}
    >
        <div className={Style['comment-group-item-wrapper']} ref={commentGroupItemWrapperRef}>
            {renderList()}
        </div>
        <div style={{ padding: '0 16px', marginTop: -8, marginBottom: 8 }}>
            {isActive && !editableCommentId
                ? <CommentInput
                    content=''
                    groupId={groupId}
                    addComment={props.addComment}
                    updateComment={props.updateComment}
                    readOnly={false}
                    commentGroupItemWrapperRef={commentGroupItemWrapperRef}
                />
                : null}
        </div>
    </div>;
};

export default CommentGroup;
